import Header from "./Header";
import Taisao from "./Taisao";
import Tantam from "./Tantam";
import Quytrinh from "./Quytrinh";
import Danhgia from "./Danhgia";
import Contact from "./Contact";

export default function Baophi() {
    return(
        <div>
            <Header />
            <Taisao />
            <Tantam />
            <Quytrinh />
            <Danhgia />
            <Contact />
        </div>
    )
}